export default "__VITE_ASSET__DhtztuZF__"